if (!customElements.get('franchise-bar')) {
  class FranchiseBar extends HTMLElement {
    constructor() {
      super();

      this.contact = this.querySelector('.franchise__contact');

      this.bindEvents();
    }

    bindEvents() {
      this.contact.addEventListener('click', function(e) {
        e.preventDefault();
        PodiumWebChat.open();
      });
    }
  }

  customElements.define('franchise-bar', FranchiseBar);
}
